<template>
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.00033 2.33171C4.31843 2.33171 1.33366 5.31647 1.33366 8.99837C1.33366 12.6803 4.31843 15.665 8.00033 15.665C11.6822 15.665 14.667 12.6803 14.667 8.99837C14.667 5.31647 11.6822 2.33171 8.00033 2.33171Z" fill="currentColor"/>
        <path d="M8 11.9985L8 9.49854" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
        <circle cx="8" cy="5.99805" r="1" transform="rotate(-180 8 5.99805)" fill="white"/>
    </svg>
</template>
